<template>
  <div id="app">
    <c-nav-header />
    <b-alert v-if="auth && auth.user && auth.user.entreprise && auth.user.entreprise.statut == 'Alerte'" show dismissible variant="warning" class="w-100 h5 text-center">
      Votre compte risque d'être suspendu sous peu. Merci de nous contacter.
    </b-alert>
    <b-alert v-if="auth && auth.user && auth.user.entreprise && auth.user.entreprise.statut == 'Bloqué'" show variant="danger" class="w-100 h3 text-center">
      Votre compte est bloqué, vous ne pouvez plus passer de commande. Merci de nous contacter.
    </b-alert>
    <main role="main" class="mt-xl-2 mb-5" id="main">
      <router-view />
    </main>
    <c-footer />
  </div>
</template>

<script>
import cHeader from './components/Header/Header.vue';
import cFooter from './components/Footer/Footer.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    'c-nav-header': cHeader,
    'c-footer': cFooter,
  },
  computed: {
    ...mapGetters([
      'auth',
    ]),
  },
};
</script>

<style lang="scss">
@import '../sass/_variables';

#main {
  min-height: 540px;
}
</style>
